import { Box, Typography, Chip } from '@mui/material';

interface PlanHeaderProps {
    name: string;
    description?: string;
    isPlanActive: boolean;
}

export const PlanHeader = ({ name, description, isPlanActive }: PlanHeaderProps) => {
    return (
        <Box sx={{ marginBottom: 3 }}>
            <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', mb: 2 }}>
                <Box sx={{ flex: 1 }}>
                    <Typography 
                        variant="h4" 
                        sx={{ 
                            fontWeight: 700,
                            color: '#1e293b',
                            marginBottom: 1,
                            letterSpacing: '-0.5px'
                        }}
                    >
                        {name}
                    </Typography>
                    <Typography 
                        sx={{ 
                            color: '#64748b',
                            fontSize: '0.95rem',
                            lineHeight: 1.6
                        }}
                    >
                        {description}
                    </Typography>
                </Box>
                <Chip
                    label={isPlanActive ? 'Active' : 'Expired'}
                    sx={{
                        marginLeft: 2,
                        fontWeight: 600,
                        fontSize: '0.75rem',
                        background: isPlanActive 
                            ? 'linear-gradient(135deg, #10b981 0%, #059669 100%)'
                            : 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
                        color: 'white',
                        boxShadow: isPlanActive 
                            ? '0 2px 8px rgba(16, 185, 129, 0.3)'
                            : '0 2px 8px rgba(239, 68, 68, 0.3)',
                    }}
                />
            </Box>
        </Box>
    );
};
